import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import NativeWelcome from './NativeWelcome';

// The app's "/" on native builds: skip the marketing website entirely.
// Signed in → straight into the app; signed out → the animated welcome.
const NativeEntry = () => {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100" style={{ background: '#2d1b69' }}>
        <div className="spinner-border text-light" role="status"><span className="visually-hidden">Loading…</span></div>
      </div>
    );
  }
  if (user) return <Navigate to={user.hasCompletedOnboarding ? '/dashboard' : '/onboarding'} replace />;
  return <NativeWelcome />;
};

export default NativeEntry;
